import type { Update } from '#global/updates/updates.ts';
import { useWhatsNewProvider } from './useWhatsNewProvider.ts';
import { WhatsNewContext } from './WhatsNewContext.ts';

type Props = {
  children: React.ReactNode;
  /** Only used by stories, which need entries the shipped (empty) list cannot provide. */
  entries?: readonly Update[];
};

/**
 * {@link WhatsNewProvider} makes useWhatsNew() available to our app.
 */
export function WhatsNewProvider({ children, entries }: Props) {
  const state = useWhatsNewProvider(entries);
  return <WhatsNewContext value={state}>{children}</WhatsNewContext>;
}
